import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Inject, Injectable } from '@angular/core';
import { ServerApi } from '../../services/server-api';
import { extractResponseBody } from '../../lib/utils';
import { IShareTrackingParams } from './share-tracking-modal.component';

@Injectable()
export class ShareTrackingService {
  constructor(@Inject(ServerApi) private api) { }

  public sendTrackingEmail(params: IShareTrackingParams): Observable<boolean> {
    return this.api.post(`dispatches/share`, { email_addresses: params.email_addresses, dispatch_id: params.dispatch_id })
      .pipe(
        map(extractResponseBody),
        map((res: { message: string, result: boolean }) => {
          return res.result;
        }),
      )
    ;
  }
}
